import { WeightUnit } from '../../../enums/weight-unit';

// source: WebV3Api.PublicContracts.Common.WeightUnit
const ORDINAL_TO_WEIGHT_UNIT = {
  0: WeightUnit.Unknown,
  1: WeightUnit.Ounces,
  2: WeightUnit.Grams,
  3: WeightUnit.Pounds,
  4: WeightUnit.Kilograms,
};

export const weightUnitEnumFromOrdinal = (ordinalValue) => {
  const defaultEnum = WeightUnit.Ounces;
  return ORDINAL_TO_WEIGHT_UNIT[ordinalValue] ?? defaultEnum;
};
